import { CountryCode, parsePhoneNumberFromString } from 'libphonenumber-js/min';

export function formatPhoneNumber(value: string | null, countryCode: CountryCode = 'US'): unknown {
    return value ? parsePhoneNumberFromString(value, countryCode)?.formatNational() : null;
}

export function unformatPhoneNumber(value: string | null, countryCode: CountryCode = 'US'): unknown {
    return value ? parsePhoneNumberFromString(value, countryCode)?.number.replace('+', '') : null;
}
